import {Component, Inject, OnInit} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiService} from './shared/services/api.service';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import {InternalService} from './shared/services/internal.service';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from "@angular/platform-browser";
import {CookieService} from "ngx-cookie-service";
import { KioskApiService } from './shared/services/kiosk-api.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private title: Title,
    private apiService: ApiService,
    private kApiService: KioskApiService,
    @Inject(SESSION_STORAGE) private session: WebStorageService,
    public internalService: InternalService,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private router: Router,
    public translete: TranslateService,
    public oidcSecurityService: OidcSecurityService, public http: HttpClient,) {
  }


  ngOnInit() {
    if (this.cookieService.get('dir') == 'rtl' || this.cookieService.get('dir') == null || !this.cookieService.get('dir')) {
      this.apiService.currentDirection = this.cookieService.get('dir');
      this.kApiService.currentDirection = this.cookieService.get('dir');
      this.changeLang('fa-ir');
        this.title.setTitle('خدمات مدیس');
      this.cookieService.set('lang' ,'1');
    } else {
      this.apiService.currentDirection = this.cookieService.get('dir');
      this.kApiService.currentDirection = this.cookieService.get('dir');
      this.changeLang('en-us');
        this.title.setTitle('Medis services');
    }
      //console.log(this.oidcSecurityService.getToken())
  }


  changeLang(language) {
    this.internalService.changeLang(language, 0);
  }

}
